import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted, onUnmounted } from 'vue';
import { isMobile, isTablet, getDeviceType } from '@/utils/mobile';

// 在页面加载时检测设备类型，并添加对应的class到body

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

onMounted(() => {
  const deviceType = getDeviceType();
  document.body.classList.add(`device-${deviceType}`);
  
  if (isMobile()) {
    document.body.classList.add('is-mobile');
  }
  
  if (isTablet()) {
    document.body.classList.add('is-tablet');
  }
  
  // 阻止移动端双击缩放
  document.addEventListener('dblclick', (e) => {
    if (isMobile()) {
      e.preventDefault();
    }
  }, { passive: false });
});

// 清理
onUnmounted(() => {
  document.body.className = '';
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view))
}
}

})